// extracted by mini-css-extract-plugin
export default {"table":"CodPagamenti_table__O2oNa"};